import AnimateOnClick from "@common/animations/AnimateOnClick";
import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useRouter } from "next/router";
import React from "react";

const RouteElement = ({ title, route, image_url, endIcon, mainButton, disabled }) => {
  const router = useRouter();

  return (
    <AnimateOnClick whileHover={{ scale: 1.03 }} style={{ width: "100%" }}>
      <Stack
        component="button"
        direction="row"
        gap={1}
        sx={(theme) => ({
          display: "flex",
          width: "100%",
          backgroundColor: mainButton
            ? theme.palette.secondary.main
            : theme.palette.secondary.light,
          color: theme.palette.secondary.contrastText,
          borderRadius: 1,
          overflow: "hidden",
          height: image_url && 80,
          border: "none",
          boxShadow: 1,
          "&:hover": {
            cursor: "pointer",
            backgroundColor: mainButton
              ? theme.palette.secondary.dark
              : theme.palette.secondary.main,
          },
          "&:disabled": {
            backgroundColor: "#000",
            opacity: 0.4,
            color: "#fff",
          },
        })}
        justifyContent="center"
        alignItems="center"
        onClick={() => router.push(route)}
        disabled={disabled}
      >
        {image_url && (
          <Box
            sx={{
              display: "block",
              width: "40%",
              height: 0,
              paddingTop: "40%",
              objectFit: "contain",
              position: "relative",
              borderRadius: 4,
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={image_url}
              alt={title}
              sx={{
                position: "absolute",
                top: "0",
                objectFit: "cover",
                width: "100%",
                height: "100%",
              }}
            />
          </Box>
        )}
        <Typography
          sx={{
            flex: 1,
            fontWeight: 500,
            wordBreak: "break-word",
            p: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
          }}
          textAlign="center"
        >
          {title}
          {endIcon}
        </Typography>
      </Stack>
    </AnimateOnClick>
  );
};

export default RouteElement;
